import { RefreshTokenBody } from '@lemoncloud/lemon-web-core';

import { OAUTH_ENDPOINT, webCore } from '@codes/web-core';

export const useUpdateTargetSite = () => {
    const updateTargetSite = async (sid: string) => {
        const { current, signature, authId, originToken } = await webCore.getTokenSignature();
        const body: RefreshTokenBody = { current, signature };
        const target = sid || window.sessionStorage.getItem('sid');

        const response = await webCore
            .signedRequest(
                'POST',
                `${OAUTH_ENDPOINT}/oauth/${authId}/refresh`,
                {
                    token: 1,
                    ...(target && { target }),
                },
                body
            )
            .catch(e => {
                console.error(e);
                throw e;
                // window.location.href = '/auth/logout';
            });

        const token = response?.data?.Token;

        const refreshToken = {
            ...token,
            identityToken: token?.identityToken || originToken.identityToken || '',
            identityPoolId: token?.identityPoolId || originToken.identityPoolId || '',
        };

        return await webCore.buildCredentialsByToken(refreshToken);
    };

    return updateTargetSite;
};
